module.exports = __webpack_public_path__ + "img/20.53c49977.jpg";